import React from "react";
import { Redirect, Route } from "react-router-dom";
import useAuth from "../hooks/useAuth";

/**
 * Frontend-side mirror of the backend's `@PreAuthorize("@access.isSuperAdmin()")`
 * on the user/role/permission endpoints (UX only — the backend still enforces
 * this independently on every request).
 */
export default function SuperAdminRoute({ children, ...rest }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="page-loading">Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={() => {
        if (!user) {
          return <Redirect to="/login" />;
        }
        return user.superAdmin ? children : <Redirect to="/dashboard" />;
      }}
    />
  );
}
